import type { HomeLauncherResponse } from '@coorum-research/shared-common/api-response'
import http from './http'

export function homeLauncherApi() {
  const getHomeLauncher = async () => {
    const response = await http.get<HomeLauncherResponse>('/home-launcher')
    return response.data
  }

  return {
    getHomeLauncher,
  }
}
